<template>
  <!-- todo: support time in some way... we kinda expect both in the same field, but there is no such input field in formulate... -->
  <div v-show="show">
    <FormKit
      :help-position="helpPosition"
      :help="field.instructions"
      :label-position="labelPosition"
      :label="field.name"
      :max="max"
      :min="min"
      :name="name"
      :placeholder="field.placeholder"
      :validation="validation"
      :value="defaultDate"
      type="date"
    />
  </div>
</template>

<script setup lang="ts">
import { fieldHelpPosition, fieldLabelPosition, fieldName, fieldValidationArray, fieldVisible } from '~/assets/formie'

interface Props {
  settings: Record<string, any>
  parentField?: Record<string, any>
  field: Record<string, any>
}

function toDateString(dateTimeString: string | undefined, fallback: any): string | any {
  if (!dateTimeString) {
    return fallback
  }
  const date = new Date(dateTimeString)
  return [
    date.getFullYear().toLocaleString('en-US', { minimumIntegerDigits: 4, useGrouping: false }),
    (date.getMonth() + 1).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }),
    date.getDate().toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }),
  ].join('-')
}

const props = defineProps<Props>()

const defaultDate = toDateString(props.field.defaultDate, null)
const helpPosition = fieldHelpPosition(props.settings, props.field)
const labelPosition = fieldLabelPosition(props.settings, props.field)
const max = toDateString(props.field.maxDate)
const min = toDateString(props.field.minDate)
const name = fieldName(props.field, props.parentField)
const show = fieldVisible(props.field)
const validation = [
  ...fieldValidationArray(props.field),
  typeof props.field.minDate === 'string' ? ['after', toDateString(props.field.minDate)] : undefined,
  typeof props.field.maxDate === 'string' ? ['before', toDateString(props.field.maxDate)] : undefined,
].filter((rule) => rule)
</script>
